import { Message } from 'element-ui'
const { createTransientMessages } = require('./transientMessages.cjs')
export const transientMessage = createTransientMessages(Message)

export function resetSessionFeedback() {
  transientMessage.resetSession()
}
